import Button from '@components/Button';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import PhoneFill from '@icons/phone/PhoneFill';
import { Link } from '@router/Link';

import RecentToolTip from '../RecentToolTip';

interface Props {
    isLastLogin?: boolean;
}

function PhoneSignInButton({ isLastLogin }:Props) {
  return (
        <Link activityName='SignInWithPhoneActivity'
              style={{ width: '100%' }}
              activityParams={{}}>
            <Button fullWidth
                    backgroundColor={colors.gray4}
                    color={colors.gray9} >
                <PhoneFill color={colors.gray9}
                              size={18}/>
                전화번호로 로그인
                {isLastLogin && (
                    <RecentToolTip/>
                )}
            </Button>
        </Link>
  );
}

export default PhoneSignInButton;
